import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api"


export const initialState = {
  staff: [],
  error: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  last_page: 1,
  current_page: 1,
  per_page: PAGELENGTH,
}

export const staffSlice = createSlice({
  name: 'staff',
  initialState: initialState,
  reducers: {
    setStaff: (state, { payload }) => {
      state.staff = payload?.data ?? payload;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page
    },
    setStaffs: (state, { payload }) => {
      state.staff = payload?.data;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page
    },
    setMoreStaffs: (state, { payload }) => {
      state.data = state.data.concat(payload.data);
      state.total = payload.total;
      state.is_more = payload.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page
    },
    removeStaff: (state, { payload }) => {
      state.error = payload
    },
    clearAllStaff: (state, { payload }) => {
      state.loader = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})

export const addStaff = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.addStaff(data)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setStaff(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const updateStaff = (data, itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.updateStaff(data, itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setStaff(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const removeStaff = (itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeStaff(itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setStaff(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const fetchStaff = (page, params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchStaff(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        dispatch(setStaffs(result.data.data));
      } else {
        dispatch(setStaffs(result.data.data));
      }
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)

  }
  !disableLoader && dispatch(setLoader(false))
}


export const changeStatus = (id, data) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.statusChange(id, data, "staff")
    if (json.status >= 200 && json.status < 300) {
      // console.log(json)
      // dispatch(setHospital(json.data))
      // callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      // callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const removeMultipleStaff = (ids, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeMultipleStaff(ids)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setHospital(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const { setStaff, setStaffs, clearAllStaff, setLoader, setError, setMoreStaffs } = staffSlice.actions


export default staffSlice.reducer
export const staffSelector = state => state.staff


